<template>
    <section class="comp_splash">
        <div class="wrp_comp_body">
            <div class="elm_logo"><span class="icon icon--logo"></span></div>
            <div v-if="loaded">
                <form class="part_form part_form_login" v-on:submit.prevent="login">
                    <div class="mod--row mod--row-16">
                        <div class="col col--12">
                            <div class="part_ui_input">
                                <input type="text" v-model="hotelCode" :placeholder="$t('hotel_code')" required
                                       :disabled="isInDomainMode() || pending">
                            </div>
                        </div>
                        <div class="col col--12">
                            <div class="part_ui_input">
                                <input id="username" type="text" v-model="username" :placeholder="$t('username')"
                                       required :disabled="pending">
                            </div>
                        </div>
                        <div class="col col--12">
                            <div class="part_ui_input">
                                <input type="password" v-model="password" :placeholder="$t('password')"
                                       required :disabled="pending">
                            </div>
                        </div>
                        <div class="col col--12">
                            <button class="part_ui_btn part_ui_btn_primary mod--shadow col--12" :disabled="pending">
                                <span>{{ $t('login') }}</span>
                                <span class="icon icon--spinner animated--load" v-if="pending"/>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="wrp_comp_foot">
            <div class="elm_spinner" v-if="loaded === false">
                <span class="icon icon--spinner animated--load"></span>
            </div>
            <div class="elm_version">
                <span>{{ $t('version') }}: {{ version }}</span>
            </div>
        </div>
    </section>
</template>

<script>
import router from '@/router';
import axios from 'axios';
import {version} from '../../../package'
import {isInDomainMode} from '../../main';

export default {
    name: 'login',
    data() {
        return {
            loaded: false,
            pending: false,
            username: '',
            password: '',
            hotelCode: '',
            version: version
        }
    },
    mounted() {
        if (localStorage.getItem('hotelCode')) {
            this.hotelCode = localStorage.getItem('hotelCode');
        }

        axios({
            url: '/currentuser'
        }).then(this.processCurrentUserResponse)
            .catch(error => {
                if (!error.response || error.response.status !== 404) { // No current user in session
                    if (error) {
                        error.forceShowError = true
                    }
                    this.showError(error)
                }
            })
            .finally(() => this.loaded = true);

        setTimeout(() => {
            const el = document.getElementById('username')
            if (el) {
                el.focus()
            }
        })
    },
    methods: {
        processCurrentUserResponse: function (response) {
            if (response.data.status === true) {
                localStorage.setItem('hotel', response.data.hotel);
                localStorage.setItem('hotelCode', response.data.hotelCode);
                localStorage.setItem('chainHotels',
                    JSON.stringify(Object.entries(response.data.chainHotels).map(([code, {hotel, status}]) =>
                        ({code, hotel, status})
                    ).sort((a, b) => {
                        let c = (b.status ? 1 : 0) - (a.status ? 1 : 0);
                        if (c === 0) {
                            c = a.hotel.localeCompare(b.hotel)
                        }
                        return c;
                    }))
                )
                localStorage.setItem('reportUrl', response.data.reportUrl)

                this.$root.$emit('login');

                const searchParams = new URLSearchParams(window.location.search)
                const page = searchParams.get('page')
                if (page && page.startsWith('/')) {
                    const protocol = window.location.protocol;
                    const hostname = window.location.hostname;
                    const port = window.location.port;
                    window.location = `${protocol}//${hostname}${port ? ':' + port : ''}#${page}`
                } else {
                    router.push({path: '/overview', hash: '', query: {}});
                }
            } else {
                this.showError({
                    code: 401,
                    message: this.$t(response.data.error),
                    forceShowError: true
                })
            }
        },
        isInDomainMode: function () {
            return isInDomainMode()
        },
        login: function () {
            this.pending = true;

            let bodyFormData = new FormData();
            bodyFormData.set('username', this.username);
            bodyFormData.set('password', this.password);

            localStorage.setItem('hotelCode', this.hotelCode);
            axios.defaults.headers.common['X-hotelCode'] = this.hotelCode;

            axios({
                url: '/login',
                data: bodyFormData,
                timeout: 15000
            }).then(this.processCurrentUserResponse).catch(error => {
                if (error) {
                    error.forceShowError = true
                }
                this.showError(error)
            }).finally(() =>
                this.pending = false);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/splash.vue